module.exports = __webpack_public_path__ + "static/img/O6.0b400059.png";